import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import LoadingLayer from '../../controls/LoadingLayer';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { IsEnglish } from '../../../utils/language';
import AlertAlgo from '../../controls/AlertSnack'
import { getTemplateDetail } from '../../../actions/availability';
import * as StatusCode from '../../../scripts/StatusCode';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';

import { isEmpty, formatDate } from '../../../utils';
import { createAvailabilityFromTemplate } from '../../../actions/availability';
import styles from '../../../styles/scheduleAvailability.module.css';

import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    rootProfile: {
        overflow: 'auto'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divForm: {
        padding: '10px',
        marginLeft: '16px',
        '& ul li': {
            paddingLeft: '0px !important'
        }
    },
    date: {
        marginBottom: '15px'
    },
    divButtons: {
        textAlign: 'center',
        marginTop: '10px'
    },
    spanDay: {
        float: 'left',
        padding: '4px',
        color: '#cfcfcf',
        fontWeight: 'bold'
    },
    spanDayEnabled: {
        color: 'var(--color1)'
    },
    spanLabel: {
        fontWeight: 'bold'
    },
    spanValue: {
        marginLeft: '5px',
        marginRight: '15px'
    }
}));

function TemplateForm(props) {
    const classes = useStyles();

    const [data, setData] = useState(props.dataTemplate);
    const [dataTemplate, setDataTemplate] = useState([]);
    const [template, setTemplate] = useState(null);
    const [isProcessing, setIsProcessing] = useState(true);
    const [dense, setDense] = React.useState(false);
    const [scheduleAvailabilityId, setScheduleAvailabilityId] = useState(props.scheduleAvailabilityId);

    const alertRef = useRef(null);

    useEffect(() => {
        setIsProcessing(false);
    }, []);

    useEffect(() => {
        if (template != null) {
            loadDataTemplate();
        }
    }, [template]);

    const loadDataTemplate = async () => {
        setIsProcessing(true);

        var response = await getTemplateDetail(template);

        if (response.status == StatusCode.STATUS_OK) {
            setDataTemplate(response.result);
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }
        setIsProcessing(false);
    }

    const isValidData = () => {
        let message = '';

        if (isEmpty(template)) {
            message = i18next.t('scheduleAvailability:template.message.template-form');
        }

        if (message.length > 0) {
            showMessageError(message);
            return false;
        }

        return true;
    }

    const handleSave = () => {
        if (isValidData()) {
            createAvailabilityFromTemplate(scheduleAvailabilityId, template).then((response) => {
                if (response != null && response.status != StatusCode.STATUS_OK) {
                    // Error
                    showMessageError(i18next.t('error:generic-error'));
                    return;
                };

                const createFromTemplateMode = 2;
                props.handleReloadList(createFromTemplateMode);
            })
        }
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const onTemplateChange = (event) => {
        setTemplate(event.target.value);
    }

    return (
        <div id={"divTemplateForm"} className={styles.rootSchedulePopBody}>
            <LoadingLayer isActive={isProcessing}>
                <FormControl>
                    <div className={styles.divFormSelect}>
                        <InputLabel>{i18next.t('scheduleAvailability:template.form.availabilityModel')}</InputLabel>
                        <Select
                            id="selectTemplate"
                            onChange={onTemplateChange}
                            value={template || ''}
                        >
                            {data && data.map((obj, index) =>
                                <MenuItem key={index} className={styles.selectItem} value={obj.id}>{`${obj.code} - ${IsEnglish() ? obj.descriptionF : obj.descriptionF}`}</MenuItem>
                            )}
                        </Select>
                    </div>
                </FormControl>
                <div className={styles.listAvailability}>
                    <List dense={dense}>
                        {dataTemplate != null && dataTemplate.map((obj, index) =>
                            <ListItem key={index}>
                                <ListItemText
                                    primary={
                                        <React.Fragment>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:list.startTime')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.startTime}
                                            </span>
                                            <span className={classes.spanLabel}>
                                                {i18next.t('scheduleAvailability:list.endTime')}{i18next.t('common:labelSeparator')}
                                            </span>
                                            <span className={classes.spanValue}>
                                                {obj.endTime}
                                            </span>
                                        </React.Fragment>
                                    }
                                    secondary={
                                        <React.Fragment>
                                            <span className={`${classes.spanDay} ${obj.day1 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.sundayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day2 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.mondayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day3 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.tuesdayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day4 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.wednesdayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day5 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.thursdayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day6 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.fridayAbbr')}
                                            </span>
                                            <span className={`${classes.spanDay} ${obj.day7 ? classes.spanDayEnabled : ''}`}>
                                                {i18next.t('scheduleAvailability:list.saturdayAbbr')}
                                            </span>
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                        )}
                    </List>
                </div>
                <div className="formDivButtons">
                    <Button onClick={handleSave} variant="success" className="saveButton">
                        {i18next.t('buttons:save')}
                    </Button>
                </div>
                <AlertAlgo ref={alertRef} />
            </LoadingLayer>
        </div>
    );
}

export default withNamespaces(['buttons', 'scheduleAvailability', 'weekday', 'error'], { wait: true })(TemplateForm);